import { Component, OnInit } from '@angular/core';
import { TimetableService } from '../services/mock-data.service';
import { MonthTimetable } from '../models/event.model';

@Component({
    selector: 'app-timetable',
    templateUrl: './timetable.component.html',
    styleUrls: ['./timetable.component.css'],
    standalone: false
})
export class TimetableComponent  {
  mode: 'face' | 'online' = 'face';
  testTypes = ['Mock Test', 'Year 4 Topic Test', 'Topic Test'];
  selectedType = 'Mock Test';
  months = ['April', 'May', 'June', 'July', 'August'];
  selectedMonth = 'April';

  showCenterPopup = false;
  selectedTest: any = null;

  tests = [
    //--------------- MARCH ---------------------
    {
      category: 'CSSE Pattern',
      details: 'CSSE Pattern Mock Exam | Paper-1 Maths, Paper-2 English Reading Comprehension & Creative Writing | Chelmsford, Ilford, Basildon, Southend',
      tests: [
        {
          id: 1,
          name: 'CSSE01 | SET 01',
          date: 'Sat 15 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'face',
          centers: [
            { name: 'Chelmsford', time: '01:00 PM - 3:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/273884eebbc23ffd9f5dd171ad871b5b' }
          ]
        },
        {
          id: 2,
          name: 'CSSE01 | SET 01',
          date: 'Sun 16 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 08:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/72c98fe39eba6098bece58ccb591fab8' },
            { name: 'Basildon', time: '04:00 PM - 06:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/74c2e5c5f8175d548d52d96114549398' },
            { name: 'Southend-On-Sea', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 3,
          name: 'CSSE01 | SET 01',
          date: 'From 16 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/3210adcfc8bad1f1e08b2b66ddd57589'
        },
        {
          id: 4,
          name: 'CSSE02 | SET 02',
          date: 'From 06 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/2f441ba76acd2cb42263ded7968721c4'
        },
        {
          id: 6,
          name: 'CSSE03 | SET 03',
          date: 'From 27 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/9930536a969799c04cd80acd0f654dd5'
        },

        {
          id: 10,
          name: 'CSSE04 | SET 04',
          date: 'From 11 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/a92c0dca871798ebdb821dd1f80f95a5'
        },

        {
          id: 13,
          name: 'CSSE05 | SET 05',
          date: 'From 25 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/90f6668f132d31f80e5b58674dd73722'
        },
        {
          id: 14,
          name: 'CSSE06 | SET 06',
          date: 'From 08 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 16,
          name: 'CSSE07 | SET 07',
          date: 'From 22 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        }
      ]
    },
    {
      category: 'GLBU Pattern',
      details: 'BUCKS, GL Assessment Maths, Eng, VR, NVR',
      tests: [
        {
          id: 4,
          name: 'GLBU01 | SET 01',
          date: 'Sun 23 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'face',
          centers: [
            { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/91b1b6864a06a4843d3d4c182de29826' }
          ]
        },
        {
          id: 5,
          name: 'GLBU01 | SET 01',
          date: 'From 23 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/c32acfd4673374894bc7702d24d17f19'
        },
        {
          id: 8,
          name: 'GLBU02 | SET 02',
          date: 'From 13 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/dd30d960a6a46d7749041ab9b9f7818f'
        },
        {
          id: 15,
          name: 'GLBU03 | SET 03',
          date: 'From 18 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/dda5fc5f97d967aa8f38c767b76ee6f5'
        }
      ]
    },
    {
      category: 'GLRB Pattern',
      details: 'GL Assessment, Redbridge Maths, Eng, VR, NVR',
      tests: [
        {
          id: 6,
          name: 'GLRB01 | SET 01',
          date: 'Sun 23 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 08:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/141a4008864648f0de9fc173908f1a28' }
          ]
        },
        {
          id: 7,
          name: 'GLRB01 | SET 01',
          date: 'From 23 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/d681e62123ab44dc1d1b3bc1171ed145'
        },
        {
          id: 10,
          name: 'GLRB02 | SET 02',
          date: 'From 13 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/8ec437821df73578e7cc6f9a44eef8b9'
        },
        {
          id: 17,
          name: 'GLRB03 | SET 03',
          date: 'From 18 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/69e9a2e35d56e41d7c7dbba2fb0a025b'
        },
        {
          id: 18,
          name: 'GLRB04 | SET 04',
          date: 'From 15 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 19,
          name: 'GLRB05 | SET 05',
          date: 'From 13 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        ,
        {
          id: 20,
          name: 'GLRB06 | SET 06',
          date: 'From 10 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 21,
          name: 'GLRB07 | SET 07',
          date: 'From 31 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        }
      ]
    },
    {
      category: 'GLKE Pattern',
      details: 'GL Assessment, Kent Maths, Eng, VR, NVR',
      tests: [
        {
          id: 8,
          name: 'GLKE01 | SET 01',
          date: 'Sun 23 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'face',
          centers: [
            { name: 'Bexleyheath', time: '12:00 PM - 02:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/beafc016ee21613b1572e85115b0bc9d' }
          ]
        },
        {
          id: 9,
          name: 'GLKE01 | SET 01',
          date: 'From 23 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/9ad59933748205a1866885ad6a2ba7a4'
        },
        {
          id: 12,
          name: 'GLKE02 | SET 02',
          date: 'From 13 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/28042dd037f39e46e52eb34e90b6f942'
        },
        {
          id: 19,
          name: 'GLKE03 | SET 03',
          date: 'From 18 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/1168b2d161bb0b64716208e66ce67025'
        },
        {
          id: 20,
          name: 'GLKE04 | SET 04',
          date: 'From 15 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 21,
          name: 'GLKE05 | SET 05',
          date: 'From 13 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        ,
        {
          id: 22,
          name: 'GLKE06 | SET 06',
          date: 'From 10 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        }
      ]
    },
    {
      category: 'FSCE Pattern',
      details: 'FSCE Style 11+ Mock Test Maths, Eng, Creative Writing',
      tests: [
        {
          id: 10,
          name: 'FSCE01 | SET 01',
          date: 'Sat 29 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'face',
          centers: [
            { name: 'Chelmsford', time: '01:00 PM - 3:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/0271cb99c6c8dbf16b0d1e6006c1078d' }
          ]
        },
        {
          id: 11,
          name: 'FSCE01 | SET 01',
          date: 'Sun 30 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/ad766ab77da4266355c894c5cfb0d8ae' },
            { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/05128621f6f46d86ac331042ff0c8310' }
          ]
        },
        {
          id: 12,
          name: 'FSCE01 | SET 01',
          date: 'From 30 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/8316c033717ac65d7af08d30e45fc32c'
        },
        {
          id: 13,
          name: 'FSCE02 | SET 02',
          date: 'From 04 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/44a912b16317692998067b5f4ea63a67'
        },
        {
          id: 14,
          name: 'FSCE03 | SET 03',
          date: 'From 01 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 15,
          name: 'FSCE04 | SET 04',
          date: 'From 29 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 16,
          name: 'FSCE05 | SET 05',
          date: 'From 27 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 17,
          name: 'FSCE06 | SET 06',
          date: 'From 17 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        }
      ]
    },
    {
      category: 'GLQE Pattern',
      details: 'GL Assessment, QE Barnet Maths, Eng, VR',
      tests: [
        {
          id: 13,
          name: 'GLQE01 | SET 01',
          date: 'Sun 30 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/f126e5e2a53b4c709f067216a4b20c35' }
          ]
        },
        {
          id: 14,
          name: 'GLQE01 | SET 01',
          date: 'From 30 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/0004a003f9de95f93e8c7f80e83faf5f'
        },
        {
          id: 15,
          name: 'GLQE02 | SET 02',
          date: 'From 04 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/b4a472b18331e36836e0eedce36dc719'
        },
        {
          id: 16,
          name: 'GLQE03 | SET 03',
          date: 'From 01 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 17,
          name: 'GLQE04 | SET 04',
          date: 'From 29 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 18,
          name: 'GLQE05 | SET 05',
          date: 'From 27 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 16,
          name: 'GLQE06 | SET 06',
          date: 'From 17 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        }
      ]
    },
    {
      category: 'GLHBS Pattern',
      details: 'GL Assessment, HBS Maths, Eng, VR, NVR',
      tests: [
        {
          id: 15,
          name: 'GLHBS01 | SET 01',
          date: 'Sun 30 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/6b7df4d958cf89ece352db065ec066b3' }
          ]
        },
        {
          id: 16,
          name: 'GLHBS01 | SET 01',
          date: 'From 30 March',
          type: 'Mock Test',
          month: 'March',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/352f4cc199a562c56aabac3a5ed95e4b'
        },
        {
          id: 17,
          name: 'GLHBS02 | SET 02',
          date: 'From 04 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/fc3d52598d472fc7141e88ff2625ab61'
        },
        {
          id: 18,
          name: 'GLHBS03 | SET 03',
          date: 'From 01 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 19,
          name: 'GLHBS04 | SET 04',
          date: 'From 29 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 20,
          name: 'GLHBS05 | SET 05',
          date: 'From 27 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 21,
          name: 'GLHBS06 | SET 06',
          date: 'From 17 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        }
      ]
    },
  
    //--------------- APRIL ---------------------
    {
      category: 'CSSE Pattern',
      details: 'CSSE Pattern Mock Exam | Paper-1 Maths, Paper-2 English Reading Comprehension & Creative Writing | Chelmsford, Ilford, Basildon, Southend',
      tests: [
        {
          id: 1,
          name: 'CSSE02 | SET 02',
          date: 'Sat 05 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'face',
          centers: [
            { name: 'Chelmsford', time: '01:00 PM - 3:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/3f3c531f94811931d40af2e7cb1bef30' }
          ]
        },
        {
          id: 2,
          name: 'CSSE02 | SET 02',
          date: 'Sun 06 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 08:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/a1c92f367d898d64214237c2218d9099' },
            { name: 'Basildon', time: '04:00 PM - 06:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/8b5cd988b16cf9d2d698e13d0f966855' },
            { name: 'Southend-On-Sea', time: '09:30 AM - 12:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/8fe3a70fe47414e6ecb41b139360fca5' }
          ]
        },
        {
          id: 4,
          name: 'CSSE03 | SET 03',
          date: 'Sat 26 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'face',
          centers: [
            { name: 'Chelmsford', time: '01:00 PM - 3:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/0dd291df3c214434118c5f354c5d663d' }
          ]
        },
        {
          id: 5,
          name: 'CSSE03 | SET 03',
          date: 'Sun 27 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 08:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/4be6b14adeaf5768c8e0e94c8e8d70bf' },
            { name: 'Basildon', time: '04:00 PM - 06:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/5c654e134d73d2618f8f7cd5be1754da' },
            { name: 'Southend-On-Sea', time: '09:30 AM - 12:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/bb4f1fb62340fa7c2b57a58e209e4516' }
          ]
        },
        

      ]
    },
    {
      category: 'GLBU Pattern',
      details: 'BUCKS, GL Assessment Maths, Eng, VR, NVR',
      tests: [
        {
          id: 7,
          name: 'GLBU02 | SET 02',
          date: 'Sun 13 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'face',
          centers: [
            { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/1b9f7ab99375536d40495e468b7bb4f0' }
          ]
        },
      ]
    },
    {
      category: 'GLRB Pattern',
      details: 'GL Assessment, Redbridge Maths, Eng, VR, NVR',
      tests: [
        {
          id: 9,
          name: 'GLRB02 | SET 02',
          date: 'Sun 13 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/7414eabb20c475766bfb4cdac41b8cf4' }
          ]
        }
      ]
    },
    {
      category: 'GLKE Pattern',
      details: 'GL Assessment, Kent Maths, Eng, VR, NVR',
      tests: [
        {
          id: 11,
          name: 'GLKE02 | SET 02',
          date: 'Sun 13 April',
          type: 'Mock Test',
          month: 'April',
          mode: 'face',
          centers: [
            { name: 'Bexleyheath', time: '12:00 PM - 02:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/cbde1b92bae4bcab7676928a18152c47' }
          ]
        }
      ]
    },
  
    //--------------- MAY ---------------------
    {
      category: 'FSCE Pattern',
      details: 'FSCE Style 11+ Mock Test Maths, Eng, Creative Writing',
      tests: [
        {
          id: 1,
          name: 'FSCE02 | SET 02',
          date: 'Sat 03 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'face',
          centers: [
            { name: 'Chelmsford', time: '01:00 PM - 3:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/68cb3ebe8191b3458eac90df056b00b3' }
          ]
        },
        {
          id: 2,
          name: 'FSCE02 | SET 02',
          date: 'Sun 04 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/633aed1f820f2594692fe6bc455df018' },
            { name: 'Chelmsford', time: '01:30 PM - 3:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/68cb3ebe8191b3458eac90df056b00b3' },
            { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/f5a5d829047a2a30f5cbbc1c45625285' }
          ]
        }
      ]
    },
    {
      category: 'GLQE Pattern',
      details: 'GL Assessment, QE Barnet Maths, Eng, VR',
      tests: [
        {
          id: 4,
          name: 'GLQE02 | SET 02',
          date: 'Sun 04 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/cc4d509283a3f0caa426e6f56543da6a' }
          ]
        }
      ]
    },
    {
      category: 'GLHBS Pattern',
      details: 'GL Assessment, HBS Maths, Eng, VR, NVR',
      tests: [
        {
          id: 6,
          name: 'GLHBS02 | SET 02',
          date: 'Sun 04 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/067d09b64a355896ffbd8d29c37e4e91' }
          ]
        }
      ]
    },
    {
      category: 'CSSE Pattern',
      details: 'CSSE Style 11+ Mock Test Maths, Eng, Comp, VR, Creative Writing',
      tests: [
        {
          id: 8,
          name: 'CSSE04 | SET 04',
          date: 'Sat 10 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'face',
          centers: [
            { name: 'Chelmsford', time: '01:00 PM - 3:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/8e828fc99e6e43f7486c45e219b0c2f3' }
          ]
        },
        {
          id: 9,
          name: 'CSSE04 | SET 04',
          date: 'Sun 11 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 08:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/bf4d71b1e4aeb06c1a70a5eabc005b77' },
            { name: 'Chelmsford', time: '01:30 PM - 04:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/8e828fc99e6e43f7486c45e219b0c2f3' },
            { name: 'Basildon', time: '04:00 PM - 06:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/7757c20bfaedde7c224fb11e3f97d6af' },
            { name: 'Southend-On-Sea', time: '09:30 AM - 12:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/861404f216249e6e9a3c1abb08961db5' }
          ]
        },
        {
          id: 11,
          name: 'CSSE05 | SET 05',
          date: 'Sat 24 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'face',
          centers: [
            { name: 'Chelmsford', time: '01:00 PM - 3:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/52b961e20ecdedfa9c0bd2b295fb485a' }
          ]
        },
        {
          id: 12,
          name: 'CSSE05 | SET 05',
          date: 'Sun 25 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 08:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/01d3f3ee24c29fafe44819f9c3dedcf0' },
            { name: 'Basildon', time: '04:00 PM - 06:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/adefabf3a7bb989a96914496198baffe' },
            { name: 'Southend-On-Sea', time: '09:30 AM - 12:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/58bb5397ea2152a8c6d18c03e189874b' }
          ]
        },
        
      ]
    },
    {
      category: 'GLBU Pattern',
      details: 'BUCKS, GL Assessment Maths, Eng, VR, NVR',
      tests: [
        {
          id: 14,
          name: 'GLBU03 | SET 03',
          date: 'Sun 18 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'face',
          centers: [
            { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/21f1df83956a527b98dcb7642d34a683' }
          ]
        }
      ]
    },
    {
      category: 'GLRB Pattern',
      details: 'GL Assessment, Redbridge Maths, Eng, VR, NVR',
      tests: [
        {
          id: 16,
          name: 'GLRB03 | SET 03',
          date: 'Sun 18 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/1971fd68085bc3a3030b73532f62db63' }
          ]
        }
      ]
    },
    {
      category: 'GLKE Pattern',
      details: 'GL Assessment, Kent Maths, Eng, VR, NVR',
      tests: [
        {
          id: 18,
          name: 'GLKE03 | SET 03',
          date: 'Sun 18 May',
          type: 'Mock Test',
          month: 'May',
          mode: 'face',
          centers: [
            { name: 'Bexleyheath', time: '12:00 PM - 02:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test/f805ec57f1c9be48fd07cb57ec53389e' }
          ]
        }
      ]
    },
  
    //--------------- JUNE ---------------------
    {
      category: 'FSCE Pattern',
      details: 'FSCE Style 11+ Mock Test Maths, Eng, Creative Writing',
      tests: [
        {
          id: 1,
          name: 'FSCE03 | SET 03',
          date: 'Sun 01 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Chelmsford', time: '02:00 PM - 04:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 3,
          name: 'FSCE04 | SET 04',
          date: 'Sun 29 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Chelmsford', time: '02:00 PM - 04:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'GLQE Pattern',
      details: 'GL Assessment, QE Barnet Maths, Eng, VR',
      tests: [
        {
          id: 5,
          name: 'GLQE03 | SET 03',
          date: 'Sun 01 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Harrow', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 7,
          name: 'GLQE04 | SET 04',
          date: 'Sun 29 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Harrow', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        
      ]
    },
    {
      category: 'GLHBS Pattern',
      details: 'GL Assessment, HBS Maths, Eng, VR, NVR',
      tests: [
        {
          id: 9,
          name: 'GLHBS03 | SET 03',
          date: 'Sun 01 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Harrow', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 11,
          name: 'GLHBS04 | SET 04',
          date: 'Sun 29 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Harrow', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'CSSE Pattern',
      details: 'CSSE Style 11+ Mock Test Maths, Eng, Comp, VR, Creative Writing',
      tests: [
        {
          id: 13,
          name: 'CSSE06 | SET 06',
          date: 'Sun 08 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Chelmsford', time: '02:00 PM - 04:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Southend-On-Sea', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 15,
          name: 'CSSE07 | SET 07',
          date: 'Sun 22 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Chelmsford', time: '02:00 PM - 04:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Southend-On-Sea', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'GLRB Pattern',
      details: 'GL Assessment, Redbridge Maths, Eng, VR, NVR',
      tests: [
        {
          id: 17,
          name: 'GLRB04 | SET 04',
          date: 'Sun 15 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'GLKE Pattern',
      details: 'GL Assessment, Kent Maths, Eng, VR, NVR',
      tests: [
        {
          id: 19,
          name: 'GLKE04 | SET 04',
          date: 'Sun 15 June',
          type: 'Mock Test',
          month: 'June',
          mode: 'face',
          centers: [
            { name: 'Bexleyheath', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
  
    //--------------- JULY ---------------------
    {
      category: 'CSSE Pattern',
      details: 'CSSE Style 11+ Mock Test Maths, Eng, Comp, VR, Creative Writing',
      tests: [
        {
          id: 1,
          name: 'CSSE08 | SET 08',
          date: 'Sun 06 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Chelmsford', time: '02:00 PM - 04:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Southend-On-Sea', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 2,
          name: 'CSSE08 | SET 08',
          date: 'From 06 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 3,
          name: 'CSSE09 | SET09',
          date: 'Sun 20 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Chelmsford', time: '02:00 PM - 04:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Southend-On-Sea', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 4,
          name: 'CSSE09 | SET09',
          date: 'From 20 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        }
      ]
    },
    {
      category: 'GLRB Pattern',
      details: 'GL Assessment, Redbridge Maths, Eng, VR, NVR',
      tests: [
        {
          id: 5,
          name: 'GLRB05 | SET 05',
          date: 'Sun 13 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'GLKE Pattern',
      details: 'GL Assessment, Kent Maths, Eng, VR, NVR',
      tests: [
        {
          id: 7,
          name: 'GLKE05 | SET 05',
          date: 'Sun 13 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'face',
          centers: [
            { name: 'Bexleyheath', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'SET Pattern',
      details: 'Sutton Maths, Eng',
      tests: [
        {
          id: 9,
          name: 'SET 01 | SET 01',
          date: 'Sun 13 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'face',
          centers: [
            { name: 'Sutton', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 10,
          name: 'SET 01 | SET 01',
          date: 'From 13 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        }
      ]
    },
    {
      category: 'GLQE Pattern',
      details: 'GL Assessment, QE Barnet Maths, Eng, VR',
      tests: [
        {
          id: 11,
          name: 'GLQE05 | SET 05',
          date: 'Sun 27 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Harrow', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'GLHBS Pattern',
      details: 'GL Assessment, HBS Maths, Eng, VR, NVR',
      tests: [
        {
          id: 13,
          name: 'GLHBS05 | SET 05',
          date: 'Sun 27 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Harrow', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'FSCE Pattern',
      details: 'FSCE Style 11+ Mock Test Maths, Eng, Creative Writing',
      tests: [
        {
          id: 15,
          name: 'FSCE05 | SET 05',
          date: 'Sun 27 July',
          type: 'Mock Test',
          month: 'July',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Chelmsford', time: '02:00 PM - 04:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
  
    //--------------- AUGUST ---------------------
    {
      category: 'CSSE Pattern',
      details: 'CSSE Style 11+ Mock Test Maths, Eng, Comp, VR, Creative Writing',
      tests: [
        {
          id: 1,
          name: 'CSSE10 | SET10',
          date: 'Sun 03 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Chelmsford', time: '02:00 PM - 04:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Southend-On-Sea', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 2,
          name: 'CSSE10 | SET10',
          date: 'From 03 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        },
        {
          id: 3,
          name: 'CSSE11 | SET11',
          date: 'Sun 24 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Chelmsford', time: '02:00 PM - 04:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Southend-On-Sea', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 4,
          name: 'CSSE11 | SET11',
          date: 'From 24 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        }
      ]
    },
    {
      category: 'GLRB Pattern',
      details: 'GL Assessment, Redbridge Maths, Eng, VR, NVR',
      tests: [
        {
          id: 5,
          name: 'GLRB06 | SET 06',
          date: 'Sun 10 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 7,
          name: 'GLRB07 | SET 07',
          date: 'Sun 31 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'GLKE Pattern',
      details: 'GL Assessment, Kent Maths, Eng, VR, NVR',
      tests: [
        {
          id: 9,
          name: 'GLKE06 | SET 06',
          date: 'Sun 10 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'face',
          centers: [
            { name: 'Bexleyheath', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'SET Pattern',
      details: 'Sutton Maths, Eng',
      tests: [
        {
          id: 11,
          name: 'SET 02 | SET 02',
          date: 'Sun 10 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'face',
          centers: [
            { name: 'Sutton', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 12,
          name: 'SET 02 | SET 02',
          date: 'From 10 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        }
      ]
    },
    {
      category: 'FSCE Pattern',
      details: 'FSCE Style 11+ Mock Test Maths, Eng, Creative Writing',
      tests: [
        {
          id: 13,
          name: 'FSCE06 | SET 06',
          date: 'Sun 17 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'GLQE Pattern',
      details: 'GL Assessment, QE Barnet Maths, Eng, VR',
      tests: [
        {
          id: 15,
          name: 'GLQE06 | SET 06',
          date: 'Sun 17 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Harrow', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
    {
      category: 'GLHBS Pattern',
      details: 'GL Assessment, HBS Maths, Eng, VR, NVR',
      tests: [
        {
          id: 17,
          name: 'GLHBS06 | SET 06',
          date: 'Sun 17 August',
          type: 'Mock Test',
          month: 'August',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Harrow', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        }
      ]
    },
  
    //--------------- SEPTEMBER ---------------------
    {
      category: 'CSSE Pattern',
      details: 'CSSE Style 11+ Mock Test Maths, Eng, Comp, VR, Creative Writing',
      tests: [
        {
          id: 1,
          name: 'CSSE12 | SET12',
          date: 'Sun 07 September',
          type: 'Mock Test',
          month: 'September',
          mode: 'face',
          centers: [
            { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Chelmsford', time: '02:00 PM - 04:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' },
            { name: 'Southend-On-Sea', time: '03: 00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test' }
          ]
        },
        {
          id: 2,
          name: 'CSSE12 | SET12',
          date: 'From 07 September',
          type: 'Mock Test',
          month: 'September',
          mode: 'online',
          bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-mock-test'
        }
      ]
    },


    // -------------------- MOCK TEST ENDS HERE -------------------- 



    // --------------------- YEAR 04 TOPIC TESTS START HERE ---------------------


    //--------------- APRIL ---------------------
  {
    category: 'Maths Topic Tests',
    details: 'Maths-focused topic tests covering Numbers, Decimals, Fractions',
    tests: [
      {
        id: 1,
        name: 'M01 | Numbers, Factors',
        date: 'Sat 05 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/2aaf596a74d9b45758549fd2d4849f90' }
        ]
      },
      {
        id: 2,
        name: 'M01 | Numbers, Factors',
        date: 'Sun 06 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e1ca1a03fa4eb807fa89a7e2353fb7f1' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e5f0bccfa8d8e5abb5b229889726e870' },
          { name: 'Southend-on-Sea', time: '09:30 AM - 11:30 AM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/3daf4c234fcfb8cd0357058372595906' }
        ]
      },
      {
        id: 3,
        name: 'M01 | Numbers, Factors',
        date: 'From 05 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/218d86ce2079bd5b9a411b225bb287d6'
      },
      {
        id: 4,
        name: 'M02 | Decimals',
        date: 'Sun 13 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/a55f3333100139447856e39feb81e455' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/b7e695714791662d1b9f5208a487ef9d' },
          { name: 'Bexleyheath', time: '12:00 PM - 02:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/9516633789c8186328ec51d7ca8bfde7' }
        ]
      },
      {
        id: 5,
        name: 'M02 | Decimals',
        date: 'From 13 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6ea4fb3613ffaacc90bfff4c953b6139'
      },
      {
        id: 6,
        name: 'M03 | Fractions',
        date: 'Sat 26 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/7555396d5ecd61e4575867b03dfd7907' }
        ]
      },
      {
        id: 7,
        name: 'M03 | Fractions',
        date: 'Sun 27 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/2ea70400b91cb952242b8dc057c10212' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/cc89cd4b0fd03207c646ec9c6202ec81' },
          { name: 'Southend-on-Sea', time: '09:30 AM - 11:30 AM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/2e8fdaed0e974ddb20b27954a69cb975' }
        ]
      },
      {
        id: 8,
        name: 'M03 | Fractions',
        date: 'From 26 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/8a02e6eaab1c563dae80fec01f9da8d1'
      }
    ]
  },
  {
    category: 'English Comprehension Tests',
    details: 'English comprehension tests in GL and CSSE formats',
    tests: [
      {
        id: 9,
        name: 'ECOMP01 | GL 1st Comprehension',
        date: 'Sat 05 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/2aaf596a74d9b45758549fd2d4849f90' }
        ]
      },
      {
        id: 10,
        name: 'ECOMP01 | GL 1st Comprehension',
        date: 'Sun 06 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e1ca1a03fa4eb807fa89a7e2353fb7f1' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e5f0bccfa8d8e5abb5b229889726e870' },
          { name: 'Southend-on-Sea', time: '09:30 AM - 11:30 AM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/3daf4c234fcfb8cd0357058372595906' }
        ]
      },
      {
        id: 11,
        name: 'ECOMP01 | GL 1st Comprehension',
        date: 'From 05 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/218d86ce2079bd5b9a411b225bb287d6'
      },
      {
        id: 12,
        name: 'ECOMP02 | CSSE 2nd Comprehension',
        date: 'Sun 13 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/a55f3333100139447856e39feb81e455' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/b7e695714791662d1b9f5208a487ef9d' },
          { name: 'Bexleyheath', time: '12:00 PM - 02:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/9516633789c8186328ec51d7ca8bfde7' }
        ]
      },
      {
        id: 13,
        name: 'ECOMP02 | CSSE 2nd Comprehension',
        date: 'From 13 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6ea4fb3613ffaacc90bfff4c953b6139'
      }
    ]
  },
  {
    category: 'Verbal & Non-Verbal Reasoning Tests',
    details: 'Verbal and Non-Verbal Reasoning with Creative Writing',
    tests: [
      {
        id: 14,
        name: 'VRNVR01 | 1st Reasoning & CW01',
        date: 'Sat 26 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/7555396d5ecd61e4575867b03dfd7907' }
        ]
      },
      {
        id: 15,
        name: 'VRNVR01 | 1st Reasoning & CW01',
        date: 'Sun 27 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/2ea70400b91cb952242b8dc057c10212' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/cc89cd4b0fd03207c646ec9c6202ec81' },
          { name: 'Southend-on-Sea', time: '09:30 AM - 11:30 AM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/2e8fdaed0e974ddb20b27954a69cb975' }
        ]
      },
      {
        id: 16,
        name: 'VRNVR01 | 1st Reasoning & CW01',
        date: 'From 26 April',
        type: 'Year 4 Topic Test',
        month: 'April',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/8a02e6eaab1c563dae80fec01f9da8d1'
      }
    ]
  },

  //--------------- MAY ---------------------
  {
    category: 'Maths Topic Tests',
    details: 'Maths-focused topic tests covering Percentages, Money, Data Handling, Time',
    tests: [
      {
        id: 1,
        name: 'M04 | Percentages',
        date: 'Sat 03 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/038748d6b87f4b0caf4a7ca8899610bb' }
        ]
      },
      {
        id: 2,
        name: 'M04 | Percentages',
        date: 'Sun 04 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/b27b0b74bf8b474726826f9e70a496da' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/8795368d41fb1983d16428edb81fb64d' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/89cf34856bd33713ee1d987703aca34f' }
        ]
      },
      {
        id: 3,
        name: 'M04 | Percentages',
        date: 'From 03 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/32e76b70b4cb9ee325e6915f120c849d'
      },
      {
        id: 4,
        name: 'M05 | Money',
        date: 'Sat 10 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e8c664f79f3309db333048b15f93e20a' }
        ]
      },
      {
        id: 5,
        name: 'M05 | Money',
        date: 'Sun 11 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/353ece1042c1412f658fc1e1ac04b561' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/f5569028d235f60a8b341565fcb45a9c' },
          { name: 'Southend-on-Sea', time: '09:30 AM - 11:30 AM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/79fae6f89b5c1ed047cc6292e6fe185a' }
        ]
      },
      {
        id: 6,
        name: 'M05 | Money',
        date: 'From 10 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/3c6db2343a945d5015cbbbe1269eb74f'
      },
      {
        id: 7,
        name: 'M06 | Data Handling Part 1',
        date: 'Sun 18 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/a1a207f9bed0b637766be49c42bf3cbc' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e1c9cdd85480f4e566b231ee6f33c74a' },
          { name: 'Bexleyheath', time: '12:00 PM - 02:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/c2e875abebde68b7676a36d13d47186e' }
        ]
      },
      {
        id: 8,
        name: 'M06 | Data Handling Part 1',
        date: 'From 18 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/9be51202d2667190239bdbaae08e5581'
      },
      {
        id: 9,
        name: 'M07 | Day, Date and Time',
        date: 'Sat 24 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/ff8147ef749dacac96c3aee4e1fa404e' }
        ]
      },
      {
        id: 10,
        name: 'M07 | Day, Date and Time',
        date: 'Sun 25 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/a9983a7d59457b33eafeac03357545fe' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/551643d76629dee65b191a024671b282' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e05c7fe538989c78655221fafd7c3049' }
        ]
      },
      {
        id: 11,
        name: 'M07 | Day, Date and Time',
        date: 'From 24 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6d94b569d831df67fb0e31e27a976944'
      }
    ]
  },
  {
    category: 'English Comprehension Tests',
    details: 'English comprehension tests in GL and CSSE formats',
    tests: [
      {
        id: 12,
        name: 'ECOMP03 | GL 3rd Comprehension',
        date: 'Sat 03 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/038748d6b87f4b0caf4a7ca8899610bb' }
        ]
      },
      {
        id: 13,
        name: 'ECOMP03 | GL 3rd Comprehension',
        date: 'Sun 04 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/b27b0b74bf8b474726826f9e70a496da' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/8795368d41fb1983d16428edb81fb64d' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/89cf34856bd33713ee1d987703aca34f' }
        ]
      },
      {
        id: 14,
        name: 'ECOMP03 | GL 3rd Comprehension',
        date: 'From 03 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/32e76b70b4cb9ee325e6915f120c849d'
      },
      {
        id: 15,
        name: 'ECOMP04 | CSSE 4th Comprehension',
        date: 'Sat 10 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e8c664f79f3309db333048b15f93e20a' }
        ]
      },
      {
        id: 16,
        name: 'ECOMP04 | CSSE 4th Comprehension',
        date: 'Sun 11 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/353ece1042c1412f658fc1e1ac04b561' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/f5569028d235f60a8b341565fcb45a9c' },
          { name: 'Southend-on-Sea', time: '09:30 AM - 11:30 AM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/79fae6f89b5c1ed047cc6292e6fe185a' }
        ]
      },
      {
        id: 17,
        name: 'ECOMP04 | CSSE 4th Comprehension',
        date: 'From 10 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/3c6db2343a945d5015cbbbe1269eb74f'
      },
      {
        id: 18,
        name: 'ECOMP05 | GL 5th Comprehension',
        date: 'Sat 24 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/ff8147ef749dacac96c3aee4e1fa404e' }
        ]
      },
      {
        id: 19,
        name: 'ECOMP05 | GL 5th Comprehension',
        date: 'Sun 25 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/a9983a7d59457b33eafeac03357545fe' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/551643d76629dee65b191a024671b282' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e05c7fe538989c78655221fafd7c3049' }
        ]
      },
      {
        id: 20,
        name: 'ECOMP05 | GL 5th Comprehension',
        date: 'From 24 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6d94b569d831df67fb0e31e27a976944'
      }
    ]
  },
  {
    category: 'Verbal & Non-Verbal Reasoning Tests',
    details: 'Verbal and Non-Verbal Reasoning with Creative Writing',
    tests: [
      {
        id: 21,
        name: 'VRNVR02 | 2nd Reasoning & CW02',
        date: 'Sun 18 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/a1a207f9bed0b637766be49c42bf3cbc' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e1c9cdd85480f4e566b231ee6f33c74a' },
          { name: 'Bexleyheath', time: '12:00 PM - 02:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/c2e875abebde68b7676a36d13d47186e' }
        ]
      },
      {
        id: 22,
        name: 'VRNVR02 | 2nd Reasoning & CW02',
        date: 'From 18 May',
        type: 'Year 4 Topic Test',
        month: 'May',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/9be51202d2667190239bdbaae08e5581'
      }
    ]
  },
  {
    category: 'Maths Revision Tests',
    details: 'Maths revision tests for comprehensive review',
    tests: [
      {
        id: 23,
        name: 'MR01 | 1st Maths Revision',
        date: 'From 03 May',
        type: 'Topic Test',
        month: 'May',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/f449fec9679f6909ad182b9d48bf9013'
      }
    ]
  },

  //--------------- JUNE ---------------------
  {
    category: 'Maths Topic Tests',
    details: 'Maths-focused topic tests covering Percentages, Money, Data Handling, Time',
    tests: [
      {
        id: 1,
        name: 'M04 | Percentages',
        date: 'Sat 07 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 02:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/0ef9460c460645560f5bbbc1b3257ad7' }
        ]
      },
      {
        id: 2,
        name: 'M04 | Percentages',
        date: 'Sun 08 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/13dcd9816005c2b54049cd9ae872fe0d' },
          { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/49f071b8cc53cfefbaf30b292f07ac4b' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/7c829336c65a9950ee1b8debebf3d969' }
        ]
      },
      {
        id: 3,
        name: 'M04 | Percentages',
        date: 'From 07 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e276b44a5befb9ca2eda836a2e0989c8'
      },
      {
        id: 4,
        name: 'M05 | Money',
        date: 'Sat 14 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/03fe1c7cd1f888090e17988ae98059fe' }
        ]
      },
      {
        id: 5,
        name: 'M05 | Money',
        date: 'Sun 15 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/8cc942dbb815a25f7cfc5eb97469c9a3' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/8cc942dbb815a25f7cfc5eb97469c9a3' },
          { name: 'Southend-on-Sea', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/b13bff98f538a76a446d2e305a3d29ac' }
        ]
      },
      {
        id: 6,
        name: 'M05 | Money',
        date: 'From 14 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6b30a55c0a757c103de800d908abc32e'
      },
      {
        id: 7,
        name: 'M06 | Data Handling Part 1',
        date: 'Sun 22 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' },
          { name: 'Bexleyheath', time: '12:00 PM - 02:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' }
        ]
      },
      {
        id: 8,
        name: 'M06 | Data Handling Part 1',
        date: 'From 22 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99'
      },
      {
        id: 9,
        name: 'M07 | Day, Date and Time',
        date: 'Sat 28 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 02:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' }
        ]
      },
      {
        id: 10,
        name: 'M07 | Day, Date and Time',
        date: 'Sun 29 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' }
        ]
      },
      {
        id: 11,
        name: 'M07 | Day, Date and Time',
        date: 'From 28 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99'
      }
    ]
  },
  {
    category: 'English Comprehension Tests',
    tests: [
      {
        id: 12,
        name: 'ECOMP03 | GL 3rd Comprehension',
        date: 'Sat 07 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 02:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/0ef9460c460645560f5bbbc1b3257ad7' }
        ]
      },
      {
        id: 13,
        name: 'ECOMP03 | GL 3rd Comprehension',
        date: 'Sun 08 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/13dcd9816005c2b54049cd9ae872fe0d' },
          { name: 'Basildon', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/49f071b8cc53cfefbaf30b292f07ac4b' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/7c829336c65a9950ee1b8debebf3d969' }
        ]
      },
      {
        id: 14,
        name: 'ECOMP03 | GL 3rd Comprehension',
        date: 'From 07 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e276b44a5befb9ca2eda836a2e0989c8'
      },
      {
        id: 15,
        name: 'ECOMP04 | CSSE 4th Comprehension',
        date: 'Sat 14 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 03:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/03fe1c7cd1f888090e17988ae98059fe' }
        ]
      },
      {
        id: 16,
        name: 'ECOMP04 | CSSE 4th Comprehension',
        date: 'Sun 15 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/8cc942dbb815a25f7cfc5eb97469c9a3' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/8cc942dbb815a25f7cfc5eb97469c9a3' },
          { name: 'Southend-on-Sea', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/b13bff98f538a76a446d2e305a3d29ac' }
        ]
      },
      {
        id: 17,
        name: 'ECOMP04 | CSSE 4th Comprehension',
        date: 'From 14 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6b30a55c0a757c103de800d908abc32e'
      },
      {
        id: 18,
        name: 'ECOMP05 | GL 5th Comprehension',
        date: 'Sat 28 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Chelmsford', time: '01:00 PM - 02:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' }
        ]
      },
      {
        id: 19,
        name: 'ECOMP05 | GL 5th Comprehension',
        date: 'Sun 29 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' },
          { name: 'Basildon', time: '04:00 PM - 06:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' }
        ]
      },
      {
        id: 20,
        name: 'ECOMP05 | GL 5th Comprehension',
        date: 'From 28 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99'
      }
    ]
  },
  {
    category: 'Verbal & Non-Verbal Reasoning Tests',
    details: 'Verbal and Non-Verbal Reasoning with Creative Writing',
    tests: [
      {
        id: 21,
        name: 'VRNVR02 | 2nd Reasoning & CW02',
        date: 'Sun 22 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'face',
        centers: [
          { name: 'Ilford', time: '05:30 PM - 07:30 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' },
          { name: 'Amersham', time: '03:00 PM - 05:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' },
          { name: 'Bexleyheath', time: '12:00 PM - 02:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' }
        ]
      },
      {
        id: 22,
        name: 'VRNVR02 | 2nd Reasoning & CW02',
        date: 'From 22 June',
        type: 'Year 4 Topic Test',
        month: 'June',
        mode: 'online',
        bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99'
      }
    ]
  },



   //--------------------- YEAR 04 TOPIC TEST ENDS HERE  ---------------------//





   //--------------------- TOPIC TEST STARTS HERE  ---------------------//

   {
    category: 'Maths Topic Tests',
    details: 'Maths-focused topic tests covering Data Handling and Shapes',
    tests: [
      {
        id: 1,
        name: 'M12 | Data Handling Part 2',
        date: 'From 01 July',
        type: 'Topic Test',
        month: 'July',
        mode: 'online',
        centers: [
          { name: 'Online', time: '9:00 AM - 6:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test' }
        ]
      },
      {
        id: 2,
        name: 'M13 | Shapes Area Perimeter 2',
        date: 'From 01 July',
        type: 'Topic Test',
        month: 'July',
        mode: 'online',
        centers: [
          { name: 'Online', time: '9:00 AM - 6:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/71602ed081aa9c9fb28886dc9a10b6c8' }
        ]
      }
    ]
  },
  {
    category: 'English Comprehension Tests',
    details: 'English comprehension tests for advanced practice',
    tests: [
      {
        id: 3,
        name: 'ECOMP09 | 9th Comprehension',
        date: 'From 01 July',
        type: 'Topic Test',
        month: 'July',
        mode: 'online',
        centers: [
          { name: 'Online', time: '9:00 AM - 6:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/71602ed081aa9c9fb28886dc9a10b6c8' }
        ]
      }
    ]
  },
  {
    category: 'Verbal & Non-Verbal Reasoning Tests',
    details: 'Verbal and Non-Verbal Reasoning practice',
    tests: [
      {
        id: 4,
        name: 'VRNVR04 | 4th Reasoning',
        date: 'From 01 July',
        type: 'Topic Test',
        month: 'July',
        mode: 'online',
        centers: [
          { name: 'Online', time: '9:00 AM - 6:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test' }
        ]
      }
    ]
  },
  {
    category: 'Maths Revision Tests',
    details: 'Maths revision tests for comprehensive review',
    tests: [
      {
        id: 5,
        name: 'MR04 | 4th Maths Revision',
        date: 'From 01 July',
        type: 'Topic Test',
        month: 'July',
        mode: 'online',
        centers: [
          { name: 'Online', time: '9:00 AM - 6:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/21bcf6b8eb7ad0b84b91d378a7fe2f97' }
        ]
      }
    ]
  },

  {
    category: 'Maths Topic Tests',
    details: 'Maths-focused topic tests covering Algebra and Speed',
    tests: [
      {
        id: 1,
        name: 'M14 | Algebra Part 2',
        date: 'From 01 August',
        type: 'Topic Test',
        month: 'August',
        mode: 'online',
        centers: [
          { name: 'Online', time: '9:00 AM - 6:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e276b44a5befb9ca2eda836a2e0989c8' }
        ]
      },
      {
        id: 2,
        name: 'M15 | Working Speed Test',
        date: 'From 01 August',
        type: 'Topic Test',
        month: 'August',
        mode: 'online',
        centers: [
          { name: 'Online', time: '9:00 AM - 6:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6b30a55c0a757c103de800d908abc32e' }
        ]
      }
    ]
  },
  {
    category: 'English Comprehension Tests',
    details: 'English comprehension tests for advanced practice',
    tests: [
      {
        id: 3,
        name: 'ECOMP10 | 10th Reading Comprehension',
        date: 'From 01 August',
        type: 'Topic Test',
        month: 'August',
        mode: 'online',
        centers: [
          { name: 'Online', time: '9:00 AM - 6:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e276b44a5befb9ca2eda836a2e0989c8' }
        ]
      }
    ]
  },
  {
    category: 'Verbal & Non-Verbal Reasoning Tests',
    details: 'Verbal and Non-Verbal Reasoning with Creative Writing',
    tests: [
      {
        id: 4,
        name: 'CW05 | 5th Creative Writing',
        date: 'From 01 August',
        type: 'Topic Test',
        month: 'August',
        mode: 'online',
        centers: [
          { name: 'Online', time: '9:00 AM - 6:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6b30a55c0a757c103de800d908abc32e' }
        ]
      }
    ]
  },
  {
    category: 'Maths Revision Tests',
    details: 'Maths revision tests covering Algebra, Probability, and more',
    tests: [
      {
        id: 5,
        name: 'MR05 | 5th Maths Revision',
        date: 'From 01 August',
        type: 'Topic Test',
        month: 'August',
        mode: 'online',
        centers: [
          { name: 'Online', time: '9:00 AM - 6:00 PM', bookingUrl: 'https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99' }
        ]
      }
    ]
  }


//--------------------- TOPIC TEST ENDS HERE  ---------------------//

  ];


  scrollToCalendar() {
    const calendarElement = document.getElementById('calendar-section');
    if (calendarElement) {
      calendarElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  setMode(mode: 'face' | 'online') {
    this.mode = mode;
  }

  setType(type: string) {
    this.selectedType = type;
  }

  selectMonth(month: string) {
    this.selectedMonth = month;
  }

  openCenterDialog(test: any) {
    this.selectedTest = test;
    this.showCenterPopup = true;
  }

  closeCenterDialog() {
    this.showCenterPopup = false;
    this.selectedTest = null;
  }

  selectCenter(center: any) {
    window.open(center.bookingUrl, '_blank');
    this.closeCenterDialog();
  }

  bookOnlineTest(url: string) {
    window.open(url, '_blank');
  }

  filteredTests() {
    // return this.tests.map(group => ({
    //   ...group,
    //   tests: group.tests.filter(
    //     test =>
    //       test.type === this.selectedType &&
    //       test.month === this.selectedMonth &&
    //       test.mode === this.mode
    //   )
    // })).filter(group => group.tests.length > 0);

    return this.tests.map(group => ({
      ...group,
      tests: group.tests.filter(test =>
        test.type === this.selectedType &&
        test.mode === this.mode &&
        (this.mode === 'online' || test.month === this.selectedMonth)
      )
    })).filter(group => group.tests.length > 0);
  }

}
